import { remoteLogMessage } from '@gjensidige/service-error-handler';
export const logInfoMessage = (message: string) => {
  if (window.location.hostname === 'localhost') {
    console.log(message);
  } else if (window.location.hostname === 'beta.testgjensidige.se') {
    console.log(message);
  } else if (window.location.hostname === 'beta.gjensidige.se') {
    console.log(message);
  } else if (window.location.hostname === 'www.testgjensidige.se') {
    console.log(message);
  } else {
    remoteLogMessage(message, { severity: 'INFO' });
  }
};
